// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"Rr-z","giftOrPromoSelector":"Sr-z","disabled":"Tr-z","subTitle":"Ur-z","selectShipAddressMessage":"Vr-z","changePayment":"Wr-z"};